import { defineRouting } from 'next-intl/routing'

import { defaultLocale, locales } from './locales'

export const routing = defineRouting({
    locales: [...locales],
    defaultLocale,
    // We do not locale-detect unprefixed entry points. The only unprefixed route
    // is the homepage, which `src/proxy.ts` serves at the bare host `/` as the
    // default locale unconditionally (see routing-middleware RD-3); every other
    // route is locale-prefixed. Disabling detection makes that explicit and keeps
    // `/` from silently resurrecting a cookie/Accept-Language redirect if the proxy
    // carve-out is ever changed.
    localeDetection: false,
})

export type Locale = (typeof routing.locales)[number]
